export default __webpack_public_path__ + "static/media/Jasmine_Ivy_AHV_In_Moms_We_Trust.16dcd4e5.jpg";